// Redux Reducers
import {
  SHOW_SHORTCUTS,
  SET_STATE_SHORTCUTS,
} from "../types";

const initialState = {
  showShortcuts: false,
  stateShortcuts: true,
};

function shortcutReducer(state = initialState, action) {

  if (action.type === SHOW_SHORTCUTS) {
    return { ...state, showShortcuts: action.payload }
  }

  if (action.type === SET_STATE_SHORTCUTS) {
    return { ...state, stateShortcuts: action.payload }
  }

  return state;
};

export default shortcutReducer;
